import { createContext, useMemo, useState } from 'react';
import { Connector } from '../data/connector';
import { Product } from '../data/product';
import { SimulationType } from "../data/Simulation";
import { Tariff } from '../data/tariff';

export interface ISimulatorContext {
  codeTotal: string,
  simulationTime: string,
  tariff?: Tariff[],
  selectedProduct?: Product,
  selectedConnector?: Connector,
  simulationType?: SimulationType,
  initialBatteryLevel?: number,
  targetBatteryLevel?: number,
  setSimulationTime: (simulationTime: string) => void,
  setUserBatteryLevel: (batteryLevel: number) => void,
  setUserSimulationType: (type: SimulationType) => void,
  setSelectedConnector?: (selectedConnector: Connector) => void,
  setSelectedProduct: (selectedProduct: Product) => void,
  setCodeTotal: (codeTotal: string) => void,
  setTariff: (tariff: Tariff[]) => void,
  getEstimatedPrice?: (serviceId: string) => void,
  setTargetBatteryLevel: (batteryTargetLevel: number) => void,
  loggedInsight: boolean,
  setLoggedInsight: (logged: boolean) => void,
}

export const SimulatorContext = createContext<ISimulatorContext | null>(null);

export const SimulatorProvider = (props: any) => {
  const [selectedProduct, setSelectedProduct] = useState<Product>();
  const [selectedConnector, setSelectedConnector] = useState<Connector>();
  const [simulationTime, setSimulationTime] = useState('30');
  const [targetBatteryLevel, setTargetBatteryLevel] = useState(80);
  const [codeTotal, setCodeTotal] = useState('');
  const [tariff, setTariff] = useState<Tariff[]>([]);
  const [simulationType, setUserSimulationType] = useState<SimulationType>(SimulationType.Time);
  const [initialBatteryLevel, setUserBatteryLevel] = useState(20);
  const [loggedInsight, setLoggedInsight] = useState(false);

  const getEstimatedPrice = (serviceId: string) => {
    const estimatedPrice = tariff?.find(t => t.serviceId === serviceId)?.estimatedPrice

    if (estimatedPrice) {
      return (Math.round(estimatedPrice * 100 * 1.20) / 100);
    }
  }

  const values = useMemo(
    () => ({
      codeTotal, tariff, selectedProduct, simulationTime, simulationType, initialBatteryLevel, targetBatteryLevel, loggedInsight, setTargetBatteryLevel, setUserBatteryLevel, setUserSimulationType,
      selectedConnector, setSelectedConnector, setSimulationTime, setSelectedProduct, setCodeTotal, setTariff, getEstimatedPrice, setLoggedInsight
    }),
    [codeTotal, tariff, selectedProduct, selectedConnector, simulationType, initialBatteryLevel]);

  return (
    <SimulatorContext.Provider value={values}>
      {props.children}
    </SimulatorContext.Provider>
  );
};